module.exports = {"522636100":"龙泉镇","522636101":"兴仁镇","522636102":"排调镇","522636103":"扬武镇","522636202":"雅灰乡","522636203":"南皋乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/522636.json
// module id = 2525
// module chunks = 0